import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { SignInModal } from '../auth/SignInModal';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'History', href: '/#about' },
  { label: 'Teams', href: '/#teams' },
  { label: 'Sponsors', href: '/#sponsors' },
  // { label: 'Testimonials', href: '/#', todo: true },
];

export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [signInOpen, setSignInOpen] = useState(false);
  const { isAuthenticated, email, signOut } = useAuth();

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <img src="/images/sv-logo-digital.png" alt="" className="navbar-logo" />
          SV RUGBY
        </Link>

        <nav className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {NAV_LINKS.map((link) => (
            <Link key={link.label} to={link.href} onClick={() => setMenuOpen(false)}>
              {link.label}
            </Link>
          ))}
          <Link to="/schedule" onClick={() => setMenuOpen(false)}>
            Schedule
          </Link>
          <Link to="/contact" className="navbar-cta" onClick={() => setMenuOpen(false)}>
            Contact Us
          </Link>
          {isAuthenticated ? (
            <>
              <Link to="/manage-users" onClick={() => setMenuOpen(false)}>
                Manage Users
              </Link>
              <button
                type="button"
                className="navbar-auth-link"
                onClick={() => {
                  signOut();
                  setMenuOpen(false);
                }}
              >
                Sign Out{email ? ` (${email})` : ''}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="navbar-auth-link"
              onClick={() => {
                setSignInOpen(true);
                setMenuOpen(false);
              }}
            >
              Sign In
            </button>
          )}
        </nav>

        <button
          className="navbar-toggle"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
        </button>
      </div>

      <SignInModal open={signInOpen} onClose={() => setSignInOpen(false)} />
    </header>
  );
}
